// extracted by mini-css-extract-plugin
export default {"root":"Wh2EsRqPcW1miF2hOXn_","paid":"pxyXSZY8YlShZPRrKrtU","unpaid":"a1gnCLKJySMpYpTBr95g","refunded":"BL_QcARF_45L_7hGYJbl","placeHolderShimmer":"BIVr5QLBFYlR9NhODSPw"};